import { getMetaValue } from './helper-functions'
import WebFont from 'webfontloader'

/**
 * Function initializes the webfontloader.
 */
export default function init() {
  let themeDir = getMetaValue( 'wp-stylesheet-directory-uri-cdn' ) || getMetaValue( 'wp-stylesheet-directory-uri' )
  WebFont.load({
    custom: {
      families: [
        'Aeonik:n3,n4,n6',
        'SaolDisplay:n4,n5,n6,n7',
      ],
      urls: [ `${themeDir}/assets/src/fonts/fonts.css` ]
    }
  })
}
